const PORTFOLIO_DIR = "/images/portfolio";

// Every .webp in public/images/portfolio is a 1600w master with 400w and 800w
// variants generated alongside it. Other formats (the Mesa SVG, the small
// GitHub and ThincTech marks) have no variants and get a plain src.
const VARIANT_WIDTHS = [400, 800];
const MASTER_WIDTH = 1600;

export const portfolioSrc = (file) =>
  file ? encodeURI(`${PORTFOLIO_DIR}/${file}`) : null;

export const portfolioSrcSet = (file) => {
  if (!file || !/\.webp$/i.test(file)) return undefined;
  const base = file.replace(/\.webp$/i, "");
  const entries = VARIANT_WIDTHS.map(
    (w) => `${encodeURI(`${PORTFOLIO_DIR}/${base}-${w}w.webp`)} ${w}w`
  );
  entries.push(`${encodeURI(`${PORTFOLIO_DIR}/${file}`)} ${MASTER_WIDTH}w`);
  return entries.join(", ");
};
